import { geoToTile, type CameraState, type Rotation, type Zoom } from './projection.js';
export const INITIAL_CAMERA: CameraState = { center: geoToTile([-74.01,40.71]), zoom: 2, rotation: 0 };
const clampZoom = (z: number): Zoom => Math.max(1, Math.min(3, z));
const roundHashZoom = (z: number): Zoom => Math.round(clampZoom(z) * 100) / 100;
const clamp = (value: number, minimum: number, maximum: number): number =>
  Math.max(minimum, Math.min(maximum, value));
export const zoomCamera = (camera: CameraState, zoom: number): CameraState => ({ ...camera, zoom: clampZoom(zoom) });
export const rotateCamera = (camera: CameraState, delta: number): CameraState => ({ ...camera, rotation: ((camera.rotation + delta + 4) % 4) as Rotation });
export const panCamera = (camera: CameraState, dx: number, dy: number): CameraState => ({ ...camera, center: [camera.center[0] + dx, camera.center[1] + dy] });
export const cameraToHash = (camera: CameraState): string => `#x=${camera.center[0]}&y=${camera.center[1]}&z=${roundHashZoom(camera.zoom).toFixed(2)}&r=${camera.rotation}`;
export function cameraFromHash(hash: string, fallback: CameraState = INITIAL_CAMERA): CameraState {
  if (!hash.replace(/^#/, '')) return fallback;
  const params = new URLSearchParams(hash.replace(/^#/, ''));
  const parse = (name: string): number | undefined | null => {
    if (!params.has(name)) return undefined;
    const value = params.get(name);
    if (value === null || value.trim() === '') return null;
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : null;
  };
  const x = parse('x'), y = parse('y'), z = parse('z'), r = parse('r');
  if (x === null || y === null || z === null || r === null || (r !== undefined && (![0, 1, 2, 3].includes(r) || !Number.isInteger(r)))) return fallback;
  return {
    center: [clamp(x ?? fallback.center[0], 0, 2700), clamp(y ?? fallback.center[1], 0, 2800)],
    zoom: z === undefined ? fallback.zoom : roundHashZoom(z),
    rotation: (r ?? fallback.rotation) as Rotation,
  };
}
